import {SET_PRODUCT} from './types';

const initialState = {
  product: {},
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_PRODUCT:
      return {
        ...state,
        product: {...state.product, ...action.payload},
      };
    default:
      return state;
  }
}
export default reducer;
